// *******************************************************************************
// Cookie Banner
// *******************************************************************************

const cookieElement = document.querySelector('.cookie-banner');

if (cookieElement) {
  const { cookieActiveFor = 365 } = document.querySelector('.cookie-banner').dataset;
  const activeDays = Number(cookieActiveFor) || 365;

  if (!Cookies.get('cookie-banner-seen') && cookieElement) {
    cookieElement.classList.add('cookie-not-set');
  }

  attachEvent('.btn--cookie', 'click', (ev) => {
    Cookies.set('cookie-banner-seen', 'cookie-set', { expires: activeDays });
    cookieElement.classList.remove('cookie-not-set');
    setTimeout(() => {
      window.location.reload();
    }, 500);
    ev.preventDefault();
  });

  // *******************************************************************************
  // Close Banner When Escape Key Press
  // *******************************************************************************

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      cookieElement.classList.remove('is-open');
    }
  });

  // *******************************************************************************
  // Close Banner When Click Outside
  // *******************************************************************************

  document.addEventListener('click', (event) => {
    if (!cookieElement.contains(event.target)) {
      cookieElement.classList.remove('is-open');
    }
  });
}
